import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {add_tweet_to_list, remove_tweet_from_list,
        create_mylist, delete_mylist,
        add_followlist, remove_followlist, change_stock_name} from '@/util/mylist_util.js'
import {get_list_name_by_id, get_parsed_list_array,
        add_stock_to_list, remove_stock_from_lists_by_id,
        change_lists_order_up, change_lists_order_down,
        change_list_name, isValidListName} from '@/util/mylist_util_helper'
import {update_userinfo_create_list, update_userinfo_follow_list,
        update_userinfo_follow_users} from '@/util/firestore_stocklist_util.js'
import {getMapValAndUpdateIfNotExist, fetchOGPInfoFromAPI,
        fetchTweetByIdFromAPI, fetchUserInfoById,
        fetchUserInfoByName} from '@/util/tweet_info_api'
import { add_user_to_likefollow_array, get_parsed_likefollow_array } from './util/likefollow_util'

Vue.use(Vuex)

export default new Vuex.Store({
  // strictモードは本番環境ではfalseにすること
  strict: true,
  state: {
    user: {
      displayName: "",
      twitter_id: "",
      photoURL: "",
      access_token: "",
      access_token_secret: "",
      firebase_uid: "",
      create_lists: [],  // ["111,1番目のストック", ...]
      follow_lists: [],  // ["111,1番目のストック,みがわり,interimadd", ...]
      follow_users: [],  // ["interimadd,みがわり,iconurl.png", ...]
    },
    list_contents: {
      // '写真': ['12395846849690', '1928475920085'],
      // '趣味': ['32395846849690'],
    },
    isInit: false,
    isLogin: false,
    tweetInfoMap: new Map(),  // APIから取得したツイートの情報を保存しておく場所。キーはid
    ogpInfoMap: new Map(),  // APIから取得したOGP情報を保存しておく場所。キーは短縮url
  },
  getters: {
    getUserInfo(state) {
      return state.user
    },
    findRegistedList: (state) => (tweet_id) => {
      for(const list_name in state.list_contents) {
        if(state.list_contents[list_name].indexOf(tweet_id) >= 0){
          return list_name
        }
      }
      return ""
    },
    isJudgeMyListAndReturnListName: (state) => (list_id) => {
      return get_list_name_by_id(state.user.create_lists, list_id)
    },
    getListTweets: (state) => (list_name) => {
      return state.list_contents[list_name]
    },
    isInit(state) {
      return state.isInit
    },
    isLogin(state) {
      return state.isLogin
    },
    getCreateLists(state) {
      return get_parsed_list_array(state.user.create_lists)
    },
    getCreateListLength: (state) => (list_name) => {
      return state.list_contents[list_name].length
    },
    getFollowLists(state) {
      return get_parsed_list_array(state.user.follow_lists)
    },
    getLikeFollowUsers(state) {
      return get_parsed_likefollow_array(state.user.follow_users)
    }
  },
  // 同期処理
  mutations: {
    setUser(state, currentUser) {
      state.isInit = true
      if(currentUser==null){
        state.user.displayName = ""
        state.user.twitter_id = ""
        state.user.photoURL = ""
        state.user.access_token = ""
        state.user.access_token_secret = ""
        state.user.firebase_uid = ""
        state.user.create_lists = []
        state.user.follow_lists = []
        state.user.follow_users = []
        state.list_contents = {}
        state.isLogin = false
        return
      }
      console.log("current user info", currentUser)
      state.user.displayName = currentUser.twitter_name
      state.user.twitter_id = currentUser.twitter_id
      state.user.photoURL = currentUser.icon_url
      state.user.access_token = currentUser.token
      state.user.access_token_secret = currentUser.token_secret
      state.user.firebase_uid  = currentUser.uid
      state.user.create_lists = currentUser.create_list
      state.user.follow_lists = currentUser.follow_list
      state.user.follow_users = ('follow_users' in currentUser) ? currentUser.follow_users : []
      state.isLogin = true
    },
    updateUserInfo(state, new_user_info) {
      state.user = new_user_info
    },
    resetListInfo(state) {
      state.list_contents = {}
    },
    updateListInfo(state, list_info) {
      state.list_contents[list_info.list_name] = list_info.listed_tweets
    },
    addTweetToList(state, add_info) {
      const tgt_list_name = get_list_name_by_id(state.user.create_lists, add_info.list_id)
      if(tgt_list_name == "") return
      if(state.list_contents[tgt_list_name].indexOf(add_info.tweet_id) >= 0) return  // すでにリストの中にある場合は処理を飛ばす
      add_tweet_to_list(add_info.list_id, add_info.tweet_id)  // DB更新
      state.list_contents[tgt_list_name].push(add_info.tweet_id)
    },
    removeTweetFromList(state, remove_info) {
      const tgt_list_name = get_list_name_by_id(state.user.create_lists, remove_info.list_id)
      if(tgt_list_name == "") return
      remove_tweet_from_list(remove_info.list_id, remove_info.remove_tweet_id)
      const removed_list = state.list_contents[tgt_list_name].filter(id => id != remove_info.remove_tweet_id)
      state.list_contents[tgt_list_name] = removed_list
    },
    addNewCreateList(state, new_list_info) {
      state.user.create_lists = add_stock_to_list(state.user.create_lists, new_list_info.list_id, new_list_info.list_name,
                                                  state.user.displayName, state.user.twitter_id)
      state.list_contents[new_list_info.list_name] = []
    },
    deleteMylistFromStore(state, remove_list_id) {
      const delete_list_name = get_list_name_by_id(state.user.create_lists,remove_list_id)
      if(delete_list_name == "") return      
      delete state.list_contents[delete_list_name]
      state.user.create_lists = remove_stock_from_lists_by_id(state.user.create_lists, remove_list_id)
    },
    addFollowListToStore(state, follow_list_info) {
      state.user.follow_lists = add_stock_to_list(state.user.follow_lists, follow_list_info.list_id, follow_list_info.list_name,
                                                  follow_list_info.create_user_name, follow_list_info.create_user_id)
    },
    removeFollowListToStore(state, remove_list_id) {
      state.user.follow_lists = remove_stock_from_lists_by_id(state.user.follow_lists, remove_list_id)
    },
    updateCreateListOfStore(state, update_list) {
      state.user.create_lists = update_list
    },
    updateFollowListOfStore(state, update_list) {
      state.user.follow_lists = update_list
    },
    updateFollowUsersOfStore(state, update_list) {
      state.user.follow_users = update_list
    },
    changeListContentNameOfStore(state, update_info) {
      state.list_contents[update_info.after_name] = [...state.list_contents[update_info.before_name]]
      delete state.list_contents[update_info.before_name]
    },
    updateTweetInfoMap(state, updateInfo) {
      state.tweetInfoMap.set(updateInfo.id, updateInfo.tweetInfo)
    },
    updateOGPInfoMap(state, updateInfo) {
      state.ogpInfoMap.set(updateInfo.url, updateInfo.ogpInfo)
    },
  },
  // 非同期処理。基本はこちらからmutationを呼び出すことが推奨されている
  actions: {
    async createNewMylist({ commit, state }, new_list_name) {
      if(isValidListName(new_list_name) == false) return false
      const create_list_id = await create_mylist(state.user.firebase_uid, new_list_name)
      const new_list_info = {list_id:create_list_id, list_name:new_list_name}
      commit('addNewCreateList', new_list_info)
      return true
    },
    async deleteMylist({ commit, state }, delete_list_id) {
      const is_delete_success = await delete_mylist(state.user.firebase_uid, delete_list_id)
      if(is_delete_success == false){
        console.error("could not delete mylist", delete_list_id)
        return
      }
      commit('deleteMylistFromStore', delete_list_id)
    },
    async addFollowlist({ commit, state }, add_list_id) {
      const is_alerdy_follow = (get_list_name_by_id(state.user.create_lists, add_list_id) !== "")
      if(is_alerdy_follow) return false
      const list_info = await add_followlist(state.user.firebase_uid, add_list_id)
      const new_list_info = {
        list_id: add_list_id,
        list_name: list_info["list_name"],
        create_user_id: list_info["create_user_id"],
        create_user_name: list_info["create_user_name"],
      }
      commit('addFollowListToStore', new_list_info)
      return true
    },
    async removeFollowlist({ commit, state }, remove_list_id) {
      const is_remove_success = await remove_followlist(state.user.firebase_uid, remove_list_id)
      if(is_remove_success != true) return
      commit('removeFollowListToStore', remove_list_id)
    },
    async updateCreateList({ commit, state }, update_list) {
      const res = await update_userinfo_create_list(state.user.firebase_uid, update_list)
      if(res != true) return false
      commit('updateCreateListOfStore', update_list)
      return true
    },
    async changeCreateListOrderUp({ dispatch, state }, list_id) {
      dispatch("updateCreateList", change_lists_order_up(state.user.create_lists, list_id))
    },
    async changeCreateListOrderDown({ dispatch, state }, list_id) {
      dispatch("updateCreateList", change_lists_order_down(state.user.create_lists, list_id))
    },
    async changeCreateListName({ dispatch, commit, state }, list_info) {
      const res = await change_stock_name(list_info.list_id, list_info.list_name)
      if(res != true) return
      const before_name = get_list_name_by_id(state.user.create_lists, list_info.list_id)
      const after_name = list_info.list_name
      dispatch("updateCreateList", change_list_name(state.user.create_lists,
                                                    list_info.list_id, list_info.list_name))
      const update_info = {before_name:before_name, after_name:after_name}
      commit("changeListContentNameOfStore", update_info)
    },
    async updateFollowList({ commit, state }, update_list) {
      const res = await update_userinfo_follow_list(state.user.firebase_uid, update_list)
      if(res != true) return false
      commit('updateFollowListOfStore', update_list)
      return true
    },
    async changeFollowListOrderUp({ dispatch, state }, list_id) {
      dispatch("updateFollowList", change_lists_order_up(state.user.follow_lists, list_id))
    },
    async changeFollowListOrderDown({ dispatch, state }, list_id) {
      dispatch("updateFollowList", change_lists_order_down(state.user.follow_lists, list_id))
    },
    async getOGPInfo({ commit, state }, url) {
      const {getinfo, isUpdate} = await getMapValAndUpdateIfNotExist(state.ogpInfoMap, url, fetchOGPInfoFromAPI)
      if(isUpdate == true){
        commit("updateOGPInfoMap", {url: url, ogpInfo: getinfo})
      }
      return getinfo
    },
    async getTweetInfoByID({ commit, state }, id) {
      const getTweetFromAPI = async (id) => {
        const res = await fetchTweetByIdFromAPI(id, state.user.access_token, state.user.access_token_secret)
        return res
      }
      const {getinfo, isUpdate} = await getMapValAndUpdateIfNotExist(state.tweetInfoMap, id, getTweetFromAPI)
      if(isUpdate == true){
        commit("updateTweetInfoMap", {id: id, tweetInfo: getinfo})
      }
      return getinfo
    },
    async updateLikeFollowUsers({ commit, state }, update_list) {
      const res = await update_userinfo_follow_users(state.user.firebase_uid, update_list)
      if(res == false) return false
      commit("updateFollowUsersOfStore", update_list)
      return true
    },
    async addFollowUserById({ dispatch, state }, userId) {
      const userinfo = await fetchUserInfoById(userId, state.user.access_token, state.user.access_token_secret)
      if(!("id" in userinfo)) return false
      const newList = add_user_to_likefollow_array(state.user.follow_users, userinfo)
      const res = await dispatch("updateLikeFollowUsers", newList)
      return res
    },
    async addFollowUserByScreenName({ dispatch, state }, screenName) {
      const userinfo = await fetchUserInfoByName(screenName, state.user.access_token, state.user.access_token_secret)
      if(!("id" in userinfo)) return false
      const newList = add_user_to_likefollow_array(state.user.follow_users, userinfo)
      const res = await dispatch("updateLikeFollowUsers", newList)
      return res
    },
    async removeFollowUser({ dispatch, state }, userId) {
      const newList = remove_stock_from_lists_by_id(state.user.follow_users, userId)
      console.log(userId, newList)
      const res = await dispatch("updateLikeFollowUsers", newList)
      return res
    },
  },
  plugins: [createPersistedState({
    key: "Twistock",
    paths: ['user', 'list_contents', 'isInit', 'isLogin']
  })],
})
